import { render } from "./Facility.vue?vue&type=template&id=7571d852"
import script from "./Facility.vue?vue&type=script&lang=js"
export * from "./Facility.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__